import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ErrorBoundary } from './ErrorBoundary';
import './styles.css';

const ROOT_ID = 'ai-chatbot-widget';

const mount = (): void => {
  const container = document.getElementById(ROOT_ID);
  if (!container) {
    throw new Error(`Mount point #${ROOT_ID} was not found.`);
  }

  // グローバルエラーハンドラーを設定
  window.addEventListener('error', (event) => {
    console.error('=== Global Error Handler ===');
    console.error('Error:', event.error);
    console.error('Message:', event.message);
    console.error('Filename:', event.filename);
    console.error('Lineno:', event.lineno);
    console.error('Colno:', event.colno);
  });

  window.addEventListener('unhandledrejection', (event) => {
    console.error('=== Unhandled Promise Rejection ===');
    console.error('Reason:', event.reason);
    console.error('Promise:', event.promise);
  });

  ReactDOM.createRoot(container).render(
    <React.StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </React.StrictMode>
  );
};

mount();

